import { render, staticRenderFns } from "./customer-parameter.vue?vue&type=template&id=dc9d873a&scoped=true&"
import script from "./customer-parameter.vue?vue&type=script&lang=js&"
export * from "./customer-parameter.vue?vue&type=script&lang=js&"
import style0 from "./customer-parameter.vue?vue&type=style&index=0&id=dc9d873a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9d873a",
  null
  
)

export default component.exports